const messages = {
  "title": "Register",
  "resetTitle": "Welkom bij BRIDGESTONE <span class=\"text-danger\">PLUS</span>",
  "desc1": "U bent al succesvol geregistreerd op het BRIDGESTONE <span class=\"text-danger\">PLUS</span> portaal.",
  "desc2": "Vervolgens logt u in met uw E-mail adres en wachtwoord.",
  "desc3": "Log in met uw E-mail adres en wachtwoord.",
  "resetSubTitle": "Bent u nieuw hier?",
  "resetDesc": "Maak dan eerst uw nieuwe gebruikersaccount aan met de functie AANMELDEN.",
  "footer": "U wordt daarna automatisch ingelogd.",
  "resetNewPass": "STEL NIEUW WACHTWOORD IN",
  "noAccount": "Ik heb geen bankrekening",
  "error": "Onjuiste inloggegevens, probeer het opnieuw!",
  "logWithAzure": "Meld u aan met Azure"
};

export default {
  messages,
};
